module.exports = __webpack_public_path__ + "static/media/resume.3d10f048.pdf";